module.exports = __webpack_public_path__ + "img/workorderlist3.db05d76d.png";